module.exports = __webpack_public_path__ + "media/images/icon-4-90cb68bc201a46ee84f49f8f17eaffa8.svg";